import { render, staticRenderFns } from "./DigiBoardLicenceDetails.vue?vue&type=template&id=75a7f2ff&scoped=true"
import script from "./DigiBoardLicenceDetails.vue?vue&type=script&lang=js"
export * from "./DigiBoardLicenceDetails.vue?vue&type=script&lang=js"
import style0 from "./DigiBoardLicenceDetails.vue?vue&type=style&index=0&id=75a7f2ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a7f2ff",
  null
  
)

export default component.exports